'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBodyClassname = require('react-body-classname');

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _translate = require('../../redux/i18n/translate');

var _translate2 = _interopRequireDefault(_translate);

var _Util = require('components/Util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Credits = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return { currentLanguage: state.language.lang };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Credits, _Component);

  function Credits(props) {
    (0, _classCallCheck3.default)(this, Credits);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Credits.__proto__ || (0, _getPrototypeOf2.default)(Credits)).call(this, props));

    _this.state = {
      headerStyle: 'show'
    };
    return _this;
  }

  (0, _createClass3.default)(Credits, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var elements = document.getElementsByClassName('creditsContainer')[0].getElementsByClassName('hiddenTxt');
      var sizeElem = elements.length - 1;
      var index = 0;

      var interval = setInterval(function () {

        elements[index].classList.add('animated');
        elements[index].classList.add('fadeInUp');
        elements[index].classList.remove('hiddenText');

        index++;

        if (index > sizeElem) {
          clearInterval(interval);
        }
      }, 150);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$strings = this.props.strings,
          block1 = _props$strings.block1,
          block2 = _props$strings.block2,
          block3 = _props$strings.block3,
          footer = _props$strings.footer,
          name = _props$strings.name;

      var headerStyle = this.state.headerStyle;

      return _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        { transitionName: 'view', transitionAppear: true, transitionAppearTimeout: 1500, transitionEnter: true, transitionEnterTimeout: 1500, transitionLeave: true, transitionLeaveTimeout: 1500 },
        _react2.default.createElement(
          _reactBodyClassname2.default,
          { className: 'credits' },
          _react2.default.createElement(
            _Util.ScrollWrapper,
            { onWindowScroll: this.handleScroll },
            _react2.default.createElement(
              'div',
              { className: 'credits' },
              _react2.default.createElement(
                'video',
                { className: 'bgVideo', width: '100%', height: '100%', autoPlay: true, loop: true, muted: true },
                _react2.default.createElement('source', { src: this.context.baseUrl + "/media/video/bgHomeLow.mp4", type: 'video/mp4' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'container' },
                _react2.default.createElement(
                  _reactAddonsCssTransitionGroup2.default,
                  { transitionName: 'view', transitionAppear: true, transitionAppearTimeout: 1500, transitionEnter: true, transitionEnterTimeout: 1500, transitionLeave: true, transitionLeaveTimeout: 1500 },
                  _react2.default.createElement(
                    'div',
                    { key: "creditsElement4", className: "creditsElement creditos" },
                    _react2.default.createElement(
                      'div',
                      { className: 'creditsContainer' },
                      _react2.default.createElement(
                        'div',
                        { className: 'block1' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'hiddenTxt' },
                          block1.title
                        ),
                        _react2.default.createElement(
                          'ul',
                          null,
                          (0, _keys2.default)(block1.elements).map(function (key, index) {
                            return _react2.default.createElement(
                              'div',
                              { key: key, className: 'hiddenTxt' },
                              _react2.default.createElement(
                                'li',
                                null,
                                ' ',
                                block1.elements[key].job
                              ),
                              _react2.default.createElement(
                                'li',
                                null,
                                ' ',
                                block1.elements[key].personName
                              )
                            );
                          })
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'block1' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'hiddenTxt' },
                          block2.title
                        ),
                        _react2.default.createElement(
                          'ul',
                          null,
                          (0, _keys2.default)(block2.elements).map(function (key, index) {
                            return _react2.default.createElement(
                              'div',
                              { key: key, className: 'hiddenTxt' },
                              _react2.default.createElement(
                                'li',
                                null,
                                ' ',
                                block2.elements[key].job
                              ),
                              _react2.default.createElement(
                                'li',
                                null,
                                ' ',
                                block2.elements[key].personName
                              )
                            );
                          })
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'block1' },
                        _react2.default.createElement(
                          'h2',
                          { className: 'hiddenTxt' },
                          block3.title
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'hiddenTxt' },
                          _react2.default.createElement(
                            'a',
                            { href: block3.elem1.link, title: block3.elem1.name, target: '_blank' },
                            block3.elem1.name
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'footer hiddenTxt' },
                        _react2.default.createElement(
                          'p',
                          null,
                          footer.title
                        ),
                        _react2.default.createElement(
                          'a',
                          { href: footer.elem1.link, title: footer.elem1.name, target: '_blank' },
                          _react2.default.createElement('i', { className: footer.elem1.icon })
                        ),
                        _react2.default.createElement(
                          'a',
                          { href: footer.elem2.link, title: footer.elem2.name, target: '_blank' },
                          _react2.default.createElement('i', { className: footer.elem2.icon })
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Credits;
}(_react.Component), _class2.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired,
  router: _react2.default.PropTypes.object.isRequired
}, _temp)) || _class);
;

exports.default = (0, _translate2.default)('Credits')(Credits);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Credits/Credits.js
// module id = 814
// module chunks = 0